import type { MoneyFormatterData } from '../moneyFormatters/MoneyFormatter.model';
import type { RelativeMoneyFormatterData } from '../moneyFormatters/RelativeMoneyFormatter.model';
import type { TravelDurationFormatterData } from '../timeFormatters/TravelDurationFormatter.model';
import type { TimeRangeFormatterData } from '../timeFormatters/TimeRangeFormatter.model';

export interface Formatter {
  formatterType: LabelFormatterType;
}

export interface RelativeMoneyFormatterDataWithType extends Formatter {
  formatterType: LabelFormatterType.RelativeMoneyFormatter;
  data: RelativeMoneyFormatterData;
}
export interface MoneyFormatterDataWithType extends Formatter {
  formatterType: LabelFormatterType.MoneyFormatter;
  data: MoneyFormatterData;
}
export interface TimeRangeFormatterDataWithType extends Formatter {
  formatterType: LabelFormatterType.TimeRangeFormatter;
  data: TimeRangeFormatterData;
}
export interface TravelDurationFormatterDataWithType extends Formatter {
  formatterType: LabelFormatterType.TravelDurationFormatter;
  data: TravelDurationFormatterData;
}

export type LabelFormatterTypes =
  | RelativeMoneyFormatterDataWithType
  | MoneyFormatterDataWithType
  | TimeRangeFormatterDataWithType
  | TravelDurationFormatterDataWithType;

export const enum LabelFormatterType {
  RelativeMoneyFormatter = 'RelativeMoneyFormatter',
  MoneyFormatter = 'MoneyFormatter',
  TimeRangeFormatter = 'TimeRangeFormatter',
  TravelDurationFormatter = 'TravelDurationFormatter',
}
